import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, OnInit, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { Avatar } from 'primeng/avatar';
import { AvatarGroup } from 'primeng/avatargroup';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Button } from 'primeng/button';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationService, InstituicaoEnsinoService, MunicipioService, PaisService, ProvinciaService, TipoInstituicaoEnsinoService } from '../../../api/services';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { AccordionModule } from 'primeng/accordion';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { TableComponent, TableColumn } from '@app/shared/components/table/table.component';
import { MenuItem } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { Menu } from 'primeng/menu';
import { TipoInstituicaoEnumPipe } from '@app/features-modules/gestao-bolseiros/pipes/tipo-instituicao.pipe';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-mais-detalhes-intituicao-ensino',
  imports: [CommonModule, ConfirmDialog, Avatar, AvatarGroup, TagModule, Button, AccordionModule, DialogModule, 
    SelectModule, InputNumberModule, InputTextModule, TableModule, Menu, TipoInstituicaoEnumPipe],
  providers: [MessageService, ConfirmationService],
  templateUrl: './mais-detalhes-intituicao-ensino.component.html',
  styleUrl: './mais-detalhes-intituicao-ensino.component.scss',
  standalone: true
})
export class MaisDetalhesIntituicaoEnsinoComponent implements OnInit {
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }

  private route = inject(ActivatedRoute);
  instituicaoSelected = input<any>();
  @Output() onCloseModal = new EventEmitter<boolean>();
  private dialogService = inject(DialogService);
  private paisService = inject(PaisService);
  private provinciaService = inject(ProvinciaService);
  private municipioService = inject(MunicipioService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private communicationService = inject(CommunicationService);
  private tipoInstituicaoEnsinoService = inject(TipoInstituicaoEnsinoService);
  private instituicaoEnsinoService = inject(InstituicaoEnsinoService);

  profileEducationalInstitution: any;
  private subscriptions = new Subscription();

  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  educationalInstitution: any[] = [];


  vagaDetail: any;
  isLoading: boolean = false;

  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL

  constructor(private router: Router) {
    this.loadCountries();
    // this.loadTypesofEducationalInstitution();
    //  this.loadAllRepresentantes();
      // this.getAllInstituicoesEnsino();
    }
 ngOnInit(): void {
  if (this.instituicaoEnsinoId) {
    this.loadInstitutionDetails(this.instituicaoEnsinoId);
  }

  const id = Number(this.route.snapshot.paramMap.get('id'));
  if (id) {
    this.getPhoto(id);
  }

    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );
  }
  get instituicaoEnsinoId(): any {
    return this.route.snapshot.paramMap.get('id')
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    if (!country) return;
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    if (!province) return;
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  getAllInstituicoesEnsino() {
    this.instituicaoEnsinoService.list().subscribe((institutions) => {
      this.educationalInstitution = institutions;
    });
  }

  getPhoto(id: number) {
    this.instituicaoEnsinoService.getFotoInstituicaoById(id).subscribe(response => {
      if (response) {
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result; // <- exibe a imagem convertida em base64
        };
        reader.readAsDataURL(response); // <- importante: precisa ser um Blob aqui
      }
    });
  }

  loadInstitutionDetails(id: string): void {
    this.instituicaoEnsinoService.show(id).subscribe((data: any) => {
      this.profileEducationalInstitution = data;
      this.loadProvinces(this.profileEducationalInstitution?.paisID);
      this.loadMunicipalities(this.profileEducationalInstitution?.provinciaID);
      // this.courseCount = data?.cursos?.length;
    });
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }

}
